<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <!-- <agentVendorShop @select="selectHandler" /> -->
      <el-form-item label="手机(尾号)">
        <el-input
          v-model="formInline.usermobile"
          placeholder="请输入手机"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="weixinOpenid" label="openid"></el-table-column>
      <el-table-column prop="usermobile" label="手机号"></el-table-column>
      <el-table-column prop="couponName" label="优惠券名称"></el-table-column>
      <el-table-column label="优惠券类型">
        <template slot-scope="scope">{{
          scope.row.type | filterType
        }}</template>
      </el-table-column>

      <el-table-column label="抵价券数额/折扣率(%)">
        <template slot-scope="scope">{{ getCouponVal(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="已用">
        <template slot-scope="scope">
          <el-tag
            type="danger"
            size="mini"
            effect="dark"
            v-if="scope.row.isUsed"
            >已用</el-tag
          >
          <el-tag v-else type="success" size="mini" effect="dark">未用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="单号">
        <template slot-scope="scope">{{ scope.row.orderid }}</template>
      </el-table-column>
      <el-table-column label="有效日期">
        <template slot-scope="scope">
          {{ scope.row.startDate | formatDateTime }} ~
          {{ scope.row.expireDate | formatDateTime }}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
//import agentVendorShop from "@/components/layout/agentVendorShop";
import Coupon from "../../plugins/CouponClass";
//import { mapGetters } from "vuex";
export default {
  components: {
    //agentVendorShop
  },
  data() {
    return {
      formInline: {
        usermobile: undefined
      },

      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },

      tableData: []
      // vendorsList: [],
      // shopList: [],
    };
  },

  filters: {
    filterProductType(val) {
      return Coupon.limitedProductTypeList().find(ele => ele.id === val).name;
    },
    filterType(val) {
      return Coupon.typeList().find(ele => ele.id === val).name;
    }
  },
  methods: {
    // selectHandler(x) {
    //   console.log("selectHandler", x);
    //   this.formInline.agentid = x.selectedAgent.agentid;
    //   this.formInline.vendorid = x.selectedVendor.vendorid;
    //   this.formInline.machineInShopid = x.selectedShop.shopid;
    // },
    // handleCloseFP() {
    //   this.isShowAssign = false;
    // },
    // onAdd() {
    //   this.isCreate = true;
    //   this.isDialogShow = true;
    // },
    // handleEdit(item) {
    //   this.couponItem = item;
    //   this.isCreate = false;
    //   this.isDialogShow = true;
    // },
    // handleAssign(item) {
    //   console.log("handleAssign");
    //   this.couponItem = item;
    //   this.isShowAssign = true;
    //   this.assignModel = {};
    // },
    onSubmit() {
      this.queryCoupon();
    },
    // closeForm() {
    //   this.isDialogShow = false;
    //   this.isShowAssign = false;
    // },
    queryCoupon() {
      this.$axios(this.$urlMapping["查询独特优惠券"], {
        data: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          ...this.formInline
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    // filterVendor(vendorid) {
    //   let vendorNameItem = this.vendorsList.find(
    //     ele => ele && ele.vendorid === vendorid
    //   );
    //   if (vendorNameItem) {
    //     return vendorNameItem.vendorName;
    //   } else {
    //     return "无效的vendor【" + vendorid + "】";
    //   }
    // },
    handleDelete(item) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = item.id;
        this.$axios(this.$urlMapping["删除独特优惠券"], {
          data: {
            id
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    getCouponVal(item) {
      if (item.type === 1) {
        return `抵用券${item.discountAmount}元`;
      } else {
        return `折扣率${item.zhekou}%`;
      }
    },

    getShopsInStrings(row) {
      let list = [];
      if (row.vendorid == "global") {
        return "全局";
      } else {
        row.shops.forEach(ele => {
          list = list.concat(Object.values(ele));
        });
        return list.join(",");
      }
    },

    getCouponVendorName(vendorid) {
      if (vendorid == "global") {
        return "全局";
      } else {
        return this.$getVendorName(vendorid);
      }
    }
  },

  async mounted() {
    this.queryCoupon();
  }
};
</script>

<style lang="less" scoped></style>
